import React from 'react';
import { mapValues } from 'lodash';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { useCustomMeasuresDependency, useOnVideoStopCallback, useVideoPlayEffect, } from '@wix/editor-elements-preview-utils';
export function withComponentPreview(ViewerComponent) {
    return React.forwardRef(({ previewWrapperProps = {}, ...viewerProps }, ref) => {
        const { autoPlayVideo, isPlayingAllowed, borderWidth } = previewWrapperProps;
        const compRef = React.useRef(null);
        const borderWidthRef = useCustomMeasuresDependency(borderWidth);
        const getMeasuredBorderWidths = (mediaContainer) => {
            if (!borderWidthRef.current) {
                return {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                };
            }
            // When browser has a zoom border becomes a decimal value, so we must measure it (https://jira.wixpress.com/browse/TB-6482)
            const computedStyle = window.getComputedStyle(mediaContainer);
            const borderWidths = {
                top: 'Top',
                right: 'Right',
                bottom: 'Bottom',
                left: 'Left',
            };
            return mapValues(borderWidths, borderSideName => Number((computedStyle[`border${borderSideName}Width`] || '0').replace('px', '')));
        };
        React.useImperativeHandle(ref, () => ({
            getCustomMeasures: () => {
                return {
                    width: {
                        [props.id]: () => {
                            const mediaContainer = document.getElementById(props.id);
                            if (!mediaContainer) {
                                return;
                            }
                            const borderWidths = getMeasuredBorderWidths(mediaContainer);
                            const width = mediaContainer.offsetWidth;
                            return width - borderWidths.left - borderWidths.right;
                        },
                    },
                    height: {
                        [props.id]: () => {
                            const mediaContainer = document.getElementById(props.id);
                            if (!mediaContainer) {
                                return;
                            }
                            const borderWidths = getMeasuredBorderWidths(mediaContainer);
                            const height = mediaContainer.offsetHeight;
                            return height - borderWidths.top - borderWidths.bottom;
                        },
                    },
                    topOffset: {
                        [props.id]: () => {
                            const mediaContainer = document.getElementById(props.id);
                            if (!mediaContainer) {
                                return;
                            }
                            const borderWidths = getMeasuredBorderWidths(mediaContainer);
                            return borderWidths.top;
                        },
                    },
                    leftOffset: {
                        [props.id]: () => {
                            const mediaContainer = document.getElementById(props.id);
                            if (!mediaContainer) {
                                return;
                            }
                            const borderWidths = getMeasuredBorderWidths(mediaContainer);
                            return borderWidths.left;
                        },
                    },
                };
            },
            ...(compRef && compRef.current),
        }));
        useVideoPlayEffect({ compRef, isPlayingAllowed, autoPlayVideo });
        const onStop = useOnVideoStopCallback();
        const props = {
            ...viewerProps,
            ref: compRef,
            onStop: isPlayingAllowed ? undefined : onStop,
        };
        return React.createElement(ViewerComponent, { ...props });
    });
}
export default (ViewerComponent) => createComponentPreviewEntry(withComponentPreview(ViewerComponent));
//# sourceMappingURL=MediaContainer.previewWrapper.js.map